import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';

export function TextLength(props) {
  return (props.limit > 0 ? (
    <Wrapper className="textLength" invalid={props.length > props.limit}>
      ({props.length ? `${props.length} символов / ` : ''}{props.limit} символов)
    </Wrapper>
  ) : (
    <Wrapper className="textLength">({props.length} символов)</Wrapper>
  ));
}

TextLength.propTypes = {
  limit: PropTypes.number,
  length: PropTypes.number,
};

TextLength.defaultProps = {
  limit: 0,
  length: 0,
};

export default React.memo(TextLength);
